var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from "@mui/material";
/**
 * Componente responsável por renderizar o header que fica no topo de cada página do formulário inserido no survey
 */
var SurveyPageHeader = function (_a) {
    var title = _a.title, description = _a.description;
    if (!title && !description) {
        return null;
    }
    return (_jsx(Grid, __assign({ container: true, sx: { mb: 3 } }, { children: _jsxs(Grid, __assign({ item: true }, { children: [title && (_jsx(Typography, __assign({ variant: "h5", gutterBottom: true, sx: {
                        color: "text.primary",
                        fontWeight: 700,
                    } }, { children: title }))), description && (_jsx(Typography, __assign({ variant: "body2", sx: {
                        color: "text.secondary",
                        mt: 1,
                    } }, { children: description })))] })) })));
};
export default SurveyPageHeader;
